<template>
  <div class="page-not-found valign-center flex-center">
    <span>{{ $route.query.msg || "页面不存在" }}</span>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-not-found {
  width: 100%;
  height: 100%;
}
</style>